export const disabledFields = [
  {
    name: 'brandName',
    label: 'Brand Name',
  },
  {
    name: 'productName',
    label: 'Product Name',
    style: { width: '588px' },
  },
  {
    name: 'sku',
    label: 'SKU (18 Character Limit)',
  },
  {
    name: 'legacyPostId',
    label: 'Product Id',
  },
  {
    name: 'retailPrice',
    label: 'Retail Price',
  },
];

export const productInformationInput = [
  {
    label: 'Tags',
    style: { width: '894px' },
    multiselectType: 'tags',
    name: 'tags',
    inputType: 'multiselect',
  },
  {
    label: 'Intended Seasons',
    name: 'intendedSeasons',
    inputType: 'multiselect',
  },
  {
    label: 'Number of Products',
    inputType: 'input',
    name: 'numberOfProducts',
    style: { width: '180px' },
  },
  {
    label: 'Number of Shades',
    inputType: 'input',
    name: 'numberOfShades',
    style: { width: '180px' },
  },
  {
    label: 'Allergy Concerns',
    name: 'allergyConcerns',
    inputType: 'multiselect',
  },
  {
    label: 'Exercise Type',
    name: 'exerciseType',
    inputType: 'multiselect',
  },
  {
    label: 'Hair Concerns',
    name: 'hairConcerns',
    inputType: 'multiselect',
  },
  {
    label: 'Hair Type',
    name: 'hairType',
    inputType: 'multiselect',
  },
  {
    label: 'Skin Concerns',
    name: 'skinConcerns',
    inputType: 'multiselect',
  },
  {
    label: 'Skin Tone',
    name: 'skinTone',
    inputType: 'multiselect',
  },
  {
    label: 'Skin Type',
    name: 'skinType',
    inputType: 'multiselect',
  },
  {
    label: 'Scent Family',
    name: 'scentFamily',
    inputType: 'multiselect',
  },
  {
    label: 'Scent Notes',
    name: 'scentNotes',
    inputType: 'multiselect',
  },
  {
    label: 'Member Life Stage',
    name: 'memberLifeStage',
    inputType: 'multiselect',
  },
];

export const productDesignInput = [
  {
    label: 'Product Colors',
    name: 'colors',
    style: { width: '273px' },
    inputType: 'multiselect',
  },
  {
    label: 'Jewelry Color',
    name: 'jewelryColor',
    style: { width: '273px' },
    inputType: 'multiselect',
  },
  {
    label: 'Patterns',
    name: 'patterns',
    style: { width: '273px' },
    inputType: 'multiselect',
  },
  {
    label: 'Packaging',
    name: 'packaging',
    style: { width: '273px' },
    inputType: 'multiselect',
  },
];
